export enum ButtonVariants {
  PRIMARY = 'primary',
  PRIMARY_NEUTRAL = 'primary-neutral',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  LINK_PRIMARY = 'link-primary',
  LINK_SECONDARY = 'link-secondary',
  DESTRUCTIVE = 'destructive',
  FILTER = 'filter',
  ICON = 'icon',
}

export enum BadgeVariants {
  NAKED = 'naked',
  MODERN = 'modern',
  COLORED = 'colored',
}

export enum BadgeColors {
  GRAY = 'gray',
  BRAND = 'brand',
  ERROR = 'error',
  WARNING = 'warning',
  SUCCESS = 'success',
  SLATE = 'slate',
  SKY = 'sky',
  BLUE = 'blue',
  INDIGO = 'indigo',
  PURPLE = 'purple',
  PINK = 'pink',
  ORANGE = 'orange',
  WHITE = 'white',
}

export enum BadgeSizes {
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
}

export enum AlertVariants {
  DEFAULT = 'default',
  DESTRUCTIVE = 'destructive',
}

export enum StatusIndicatorVariant {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  DEFAULT = 'default',
}

export enum DialogVariants {
  DEFAULT = 'default',
  DESTRUCTIVE = 'destructive',
}

export enum EmptyStateVariants {
  INLINE = 'inline',
  DEFAULT = 'default',
  PAGE = 'page',
}

export enum ErrorStateVariants {
  INLINE = 'inline',
  DEFAULT = 'default',
  ALERT = 'alert',
}

export enum ChipVariants {
  GLUE = 'glue',
  PURPLE = 'purple',
  GREEN = 'green',
  AMBER = 'amber',
}

export enum DropdownMenuItemVariants {
  DEFAULT = 'default',
  DESTRUCTIVE = 'destructive',
}

export enum GaugeColor {
  RED = 'red',
  ORANGE = 'orange',
  YELLOW = 'yellow',
  GREEN = 'green',
  BLUE = 'blue',
  GRAY = 'gray',
}

export enum FeaturedIconVariants {
  LIGHT = 'light',
  DARK = 'dark',
  MODERN = 'modern',
}
